module.exports = __webpack_public_path__ + "static/eco_02-49d4b2322335a1267582e1677a9d4e05.jpg";